module.exports = __webpack_public_path__ + "6b4eb38834c1c730d1820ad95b0d6bcc.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/SAMI.svg
// module id = b74q
// module chunks = 0